import React, {useEffect, useState} from "react";
import {Table} from "antd";
import {formatMoney2} from "utils/moneyHelper";
import {SubCompanyInvoiceList} from "./SubCompanyInvoiceList";
import {MainTableWrapper} from "../styles/SubCompanyInvoice.styles";

const columns = [
    {title: "Firma İsmi", dataIndex: "companyName"},
    {title: "Toplam Fatura Sayısı", dataIndex: "invoiceCount"},
    {
        title: "Toplam Fatura Tutarı",
        dataIndex: "invoiceAmount",
        render: amount => formatMoney2({amount, currency: "TL"})
    },
    {
        title: "Kesilmesi Beklenen Kapıda Ödeme Tahsilat Fatura Tutarı",
        dataIndex: "unissuedCodInvoiceAmount",
        render: amount => formatMoney2({amount, currency: "TL"})
    }
];

export const CompanyInvoiceTable = ({
    rows,
    total,
    page,
    pageSize,
    onPageChange,
    loading,
    filters,
    fetchSubCompanies,
    fetchDetail
}) => {
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);
    const [subCompaniesByCompanyId, setSubCompaniesByCompanyId] = useState({});

    // Alt firma listeleri filtrelere bağlı olduğu için filtre değişince önbellek geçersiz olur
    useEffect(() => {
        setExpandedRowKeys([]);
        setSubCompaniesByCompanyId({});
    }, [JSON.stringify(filters)]);

    const loadSubCompanies = companyId => {
        if (subCompaniesByCompanyId[companyId]) return;
        setSubCompaniesByCompanyId(prev => ({...prev, [companyId]: {loading: true}}));
        fetchSubCompanies({...filters, companyId})
            .then(data => {
                // Store hata modalını gösterip undefined döner
                setSubCompaniesByCompanyId(prev => ({
                    ...prev,
                    [companyId]: data
                        ? {loading: false, data}
                        : {loading: false, error: "Alt firmalar yüklenemedi"}
                }));
            })
            .catch(err => {
                setSubCompaniesByCompanyId(prev => ({
                    ...prev,
                    [companyId]: {loading: false, error: err?.message || "Alt firmalar yüklenemedi"}
                }));
            });
    };

    const handleExpand = (expanded, record) => {
        const key = record.companyId;
        if (!expanded) {
            setExpandedRowKeys(prev => prev.filter(k => k !== key));
            return;
        }
        loadSubCompanies(key);
        setExpandedRowKeys(prev => [...prev, key]);
    };

    return (
        <MainTableWrapper>
            <Table
                columns={columns}
                dataSource={rows}
                loading={loading}
                rowKey="companyId"
                pagination={{
                    current: page,
                    pageSize,
                    total,
                    onChange: onPageChange,
                    hideOnSinglePage: true,
                    showSizeChanger: false
                }}
                expandable={{
                    expandedRowRender: record => (
                        <SubCompanyInvoiceList
                            state={subCompaniesByCompanyId[record.companyId]}
                            filters={filters}
                            fetchDetail={fetchDetail}
                        />
                    ),
                    expandedRowKeys,
                    onExpand: handleExpand
                }}
            />
        </MainTableWrapper>
    );
};
